export const HEADER_V1 = 'v1';
export const HEADER_V2 = 'v2';

export const DESKTOP_FAT_GUTTER = '60';
export const DESKTOP_THIN_GUTTER = '32';
export const MOBILE_GUTTER = '16';
